import { Link } from 'react-router-dom';
import { useEffect } from 'react';


export default function Navbar() {

  const Header = () => {
    
    // Sticky Menu Area
    useEffect(() => {
        window.addEventListener('scroll', isSticky);
        return () => {
            window.removeEventListener('scroll', isSticky);
        };
    });
  }
           
    /* Method that will fix header after a specific scrollable */
           const isSticky = (e) => {
                const header = document.querySelector('header-area');
                const scrollTop = window.scrollY;
                scrollTop >= 250 ? header.classList.add('is-sticky') : header.classList.remove('is-sticky');
            };
    return (  
      <>
      <header className='header-area'>
            <div className="site-mobile-menu site-navbar-target">
            <div className="site-mobile-menu-header">
            <div className="site-mobile-menu-close mt-3">
                <span className="icon-close2 js-menu-toggle"></span>
            </div>
            </div>
            <div className="site-mobile-menu-body"></div>
        </div>
      
      
      <div className="site-navbar-wrap">
        <div className="site-navbar-top">
          <div className="container pt-3">
            <div className="row align-items-center">
              <div className="col-12 text-right">
                <div className="header-social-icons mr-auto">
                    <a>Follow us on </a>
                  <a href="#">
                    <img src="img/instagram.png" alt="" className="social-icon" alt="social icons1" />
                  </a>
                  <a href="#">
                    <img src="img/tripadvisor.png" alt="" className="social-icon" alt="social icons2" />
                  </a>
                  <a href="#">
                    <img src="img/facebook.png" alt="" className="social-icon" alt="social icons3" />
                  </a>
                </div>
                
              </div>
            </div>
          </div>
        </div>
  
        <div className="site-navbar site-navbar-target js-sticky-header">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-2">
                <h1 className="my-0 site-logo">
                <Link to="/">
                        <img src="img/the-grand-logo.png" className="logo" alt="The Grand logo" />
                        </Link>
                </h1>
              </div>
              <div className="col-10">
                <nav className="site-navigation text-right" role="navigation">
                  <div className="container">
                    <div className="d-inline-block d-lg-none ml-md-0 mr-auto py-3">
                        <a href="#" className="site-menu-toggle js-menu-toggle text-white">
                            <span className="icon-menu h3"></span>
                        </a>
                    </div>
  
                    <ul className="site-menu main-menu d-lg-block d-none js-clone-nav">
                    <li className="active">
                        <Link to="/">Home</Link>
                    </li>
                     
                      <li>
                            <Link to="/about">About</Link>
                      </li>
                      <li>
                        <Link to="/Accomodations">Rooms</Link>
                       </li>

                       <li>
                        <Link to="/offers">Offers</Link>
                       </li>
                       <li>
                        <Link to="/weddingevents">Events & Weddings</Link>
                       </li>
                       <li>
                        <Link to="/dining">Dining</Link>
                       </li>
                       <li>
                        <Link to="/contact">Contact</Link>
                       </li>
                       <li>
                        <Link to="" id="find-reservation">Find Reservation</Link>
                       </li>
                      
                    </ul>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      

    </header>
      </>
    );
  }
  